import { Component, Input, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { ArrUtil, curLang, deepClone, Dimension } from '@gspwidget/util';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { sysVars } from '../exp-editor/monaco-controller';

export interface EditableTableColumn {
  name: string
  title?: string
  template?: any
  placeholder?: string
  type?: 'text' | 'exp' | 'number' | 'i18n'
  onClick?: () => void
}

@Component({
  selector: 'editable-table',
  templateUrl: './editable-table.component.html',
  styleUrls: ['./editable-table.component.scss']
})
export class EditableTableComponent implements OnInit {
  /** 直接修改 data */
  @Input() data: any[] = []
  @Input() columns: EditableTableColumn[]
  /** TODO: 跟维度解耦？ */
  @Input() rawDims: Dimension[] = []
  @Input() paramType: string
  @Input() keyReadonly: boolean
  @Output() dataChange = new EventEmitter<any[]>();
  @ViewChild('expModalTmpl') expModalTmpl

  modalRef: BsModalRef
  // renderData
  JSON = JSON
  sysVars = sysVars
  curExpCol: EditableTableColumn
  curRowClone
  curRowIndex = -1

  constructor (
    // private cd: ChangeDetectorRef
    private modalSvc: BsModalService,
  ) { }

  ngOnInit () {
    // this.renderData = this.data
  }

  trackByFn (i, item) {
    return i + item
  }
  deleteRow (i: number) {
    this.data.splice(i, 1)
    this.dataChange.emit(this.data);
  }
  upRow (i: number) {
    ArrUtil.UpI(this.data, i)
  }
  downRow (i: number) {
    ArrUtil.DownI(this.data, i)
  }

  handleChangeNewRowValue (colName: string, i: number, value) {
    if (i === this.data.length) {
      if (!value) return
      (this.data as any[]).push({
        [colName]: value,
        type: this.paramType
      })
      this.dataChange.emit(this.data);
      // this.renderData = this.data.slice()
    }
  }

  handleClickExp (col: EditableTableColumn, i: number) {
    const invalidIndex = i > -1 && i < this.data.length
    // 有效下标为编辑，否则为新增
    this.curRowClone = invalidIndex ? deepClone(this.data[i]) : {}
    this.curRowIndex = i
    this.curExpCol = col
    this.modalRef = this.modalSvc.show(this.expModalTmpl)
  }

  handleConfirmExp () {
    // 编辑
    if (this.curRowIndex > -1 && this.curRowIndex < this.data.length) {
      this.data[this.curRowIndex] = this.curRowClone
    } else { // 新增
      this.data.push(this.curRowClone)
    }
    this.modalRef.hide()
  }  

}
